var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * An object containing properties for notification groups
 */
var NotificationGroup = /** @class */ (function () {
    function NotificationGroup() {
    }
    return NotificationGroup;
}());
export { NotificationGroup };
/**
 * An object containing properties for notification groups
 *
 * @deprecated This is a fallback for the previous erroneous class name of NotificationGroup
 *
 * See: https://github.com/patternfly/patternfly-ng/issues/451
 */
var NotificaitonGroup = /** @class */ (function (_super) {
    __extends(NotificaitonGroup, _super);
    function NotificaitonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NotificaitonGroup;
}(NotificationGroup));
export { NotificaitonGroup };
//# sourceMappingURL=notification-group.js.map